import { render } from "./EventAdesioni.vue?vue&type=template&id=4403d0c8&scoped=true"
import script from "./EventAdesioni.vue?vue&type=script&lang=js"
export * from "./EventAdesioni.vue?vue&type=script&lang=js"

import "./EventAdesioni.vue?vue&type=style&index=0&id=4403d0c8&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_entasys/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4403d0c8"]])

export default __exports__